<div class="dialog-padding">
  <h1 mat-dialog-title>Order Random Test</h1>
  <div mat-dialog-content>
    <form [formGroup]="formGroup">
      <div>
        <mat-label>Test Type</mat-label>
        <mat-radio-group formControlName="testType">
          <mat-radio-button id="createRandomSubstanceScreening-radio-drug" [value]="screeningPackageCodes.SCREENING_PACKAGE_DRUG_CODE">
            Drug
          </mat-radio-button>
          <mat-radio-button
            id="createRandomSubstanceScreening-radio-alcohol"
            [value]="screeningPackageCodes.SCREENING_PACKAGE_DRUG_AND_ALCOHOL_CODE"
          >
            Drug and Alcohol
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </form>
  </div>
  <div mat-dialog-actions align="end">
    <button id="createRandomSubstanceScreening-button-cancel" mat-flat-button (click)="handleClose()">Cancel</button>&nbsp;&nbsp;
    <button
      id="createRandomSubstanceScreening-button-save"
      mat-flat-button
      color="primary"
      (click)="handleOrderClicked()"
      [disabled]="!formGroup.valid"
    >
      Order
    </button>
  </div>
</div>
